import { Checkbox } from 'antd';
import './VtxCheckbox.scss';
import * as React from 'react';
import { CheckboxProps, CheckboxGroupProps } from 'antd/lib/checkbox';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import { FunctionComponent } from 'react';

export interface VtxCheckboxProps extends CheckboxProps, IAutomatable {}
export interface VtxCheckboxGroupProps extends CheckboxGroupProps, IAutomatable {
    /**
     * To specify the direction of the checkbox buttons
     * @default vertical
     */
    direction?: 'horizontal' | 'vertical';
}
export type VtxCheckboxOnChangeFn = NonNullable<VtxCheckboxProps['onChange']>;

export const VtxCheckbox: FunctionComponent<VtxCheckboxProps> = React.memo((props: VtxCheckboxProps) => {
    const automationClass = 'vtx-checkbox';
    let checkboxGroupDirection;
    const { className, ...otherProps } = preventDataAutomationOverriding(props);

    const classNamesCombined = classNames(automationClass, checkboxGroupDirection, className);

    return (
        <div data-automation-class={automationClass} className={classNamesCombined}>
            <Checkbox {...otherProps}>{props.children}</Checkbox>
        </div>
    );
});

export const VtxCheckboxGroup: FunctionComponent<VtxCheckboxGroupProps> = React.memo(
    (props: VtxCheckboxGroupProps) => {
        const automationClass = 'vtx-checkbox-group';
        let checkboxGroupDirection;
        const { className, ...otherProps } = preventDataAutomationOverriding(props);

        if (props.direction === 'horizontal') {
            checkboxGroupDirection = 'vtx-checkbox-group-horizontal';
        } else {
            checkboxGroupDirection = 'vtx-checkbox-group-vertical';
        }

        const classNamesCombined = classNames(automationClass, checkboxGroupDirection, className);

        return (
            <div data-automation-class={automationClass} className={classNamesCombined}>
                <Checkbox.Group {...otherProps}></Checkbox.Group>
            </div>
        );
    }
);
